import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { SessionStorageService, SessionStorage } from '../jng2-webstorage/app';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map } from 'rxjs/operators/map';

import { ApplicationService, CollegeStaff } from '../application/application.service';
import { ConfigService } from '../config/config.service';

import { AuthPacket } from '../authentication/auth.service';

@Injectable()
export class UserService {
    @SessionStorage() private _User: UserInfo;

    UserSubject: BehaviorSubject<UserInfo> = new BehaviorSubject<UserInfo>(null);

    get User() {
        return this._User;
    }

    set User(_ui: UserInfo) {
        this._User = _ui;
        this.UserSubject.next(_ui);
    }

    constructor(
        private appService: ApplicationService,
        private storage: SessionStorageService,
        private router: Router,
        private configService: ConfigService,
        private sessionService: SessionStorageService
    ) {
        this.UserSubject.next(this._User);
    }

    // #region Clear User Service Call

    ClearUser() {
        this.User = null;

        // this.sessionService.clear();
        this.sessionService.clear('_User');

        // Clear out all session specific settings.
        this.appService.CurrentSchool = null;
        this.sessionService.clear('_currentschool');
        this.appService.SelectedSchoolYear = null;
        this.sessionService.clear('_selectedschoolyear');
        this.appService.SelectedStudent = null;
        this.sessionService.clear('_selectedstudent');
    }

    // #endregion

    // #region Set User Service Call

    SetUser(user: UserInfo) {
        const currole = this.User && this.User.CurrentRole;
        user.CurrentRole = currole;

        this.User = user;
    }

    // #endregion

    // #region Set User Current Role Service Call

    SetUserCurrentRole(role: string) {
        if (this.User.CurrentRole != null && role === this.User.CurrentRole) {
            return;
        }

        // To trigger proper session storage, we need to create a new object reference, rather than just updating our existing User object.
        const newUser: UserInfo = <UserInfo>JSON.parse(JSON.stringify(this.User));

        // Update the current role field.
        newUser.CurrentRole = role;

        // Update the "current role" bit flags based upon the role in place right now
        newUser.IsAdvisor = role === 'Advisor';
        newUser.IsCollegeAdmin = role === 'CollegeAdmin';
        newUser.IsCollegeSupport = role === 'CollegeSupport';
        newUser.IsCounselor = role === 'Counselor';
        newUser.IsDeveloper = role === 'Developer';
        newUser.IsDistrictAdmin = role === 'DistrictAdmin';
        newUser.IsDistrictUser = role === 'DistrictUser';
        newUser.IsParent = role === 'Parent';
        newUser.IsSchoolAdmin = role === 'SchoolAdmin';
        newUser.IsStudent = role === 'Student';
        newUser.IsMultiRole = newUser.Roles.IsMultiRole;

        // Now, persist it to session storage and then broadcast it for listeners.
        this.User = newUser;

        // Go to the home screen for this role.
        const homeroute = '/home';
        this.router.navigate([homeroute]);
    }

    // #endregion

    // #region Update AuthToken Service Call

    UpdateAuthToken(AuthToken: any) {
        // If the authtoken has changed, update the user record.
        if (AuthToken !== this.User.AuthToken) {
            // To trigger proper session storage, we need to create a new object reference, rather than just updating our existing
            // User object.
            const newUser: UserInfo = { ...this.User };

            // Update the AuthToken field
            newUser.AuthToken = AuthToken;

            // Now, persist it to session storage and then broadcast it for listeners
            this.User = newUser;
        }
    }

    // #endregion
}

// #region Custom Classes

export class UserInfo {
    AccountName: string;
    StaffColleges?: CollegeStaff[];
    AuthToken: string;
    CanEditTeacher: boolean;
    CanEditSchool: boolean;
    CanUploadVideos: boolean;
    CurrentRole: string;
    CurrentSchool: string;
    FirstName: string;
    SchoolName: string;
    SchoolNumber: string;
    StudentID: string;
    TargetStudentID: string;
    HasUserRole: boolean;
    ImpersonatePositionNo: string;
    ImpersonateSAPID: string;
    ImpersonationAvailable: boolean;

    IsAdvisor: boolean;
    IsCollegeAdmin: boolean;
    IsCollegeSupport: boolean;
    IsCounselor: boolean;
    IsDeveloper: boolean;
    IsDistrictAdmin: boolean;
    IsDistrictUser: boolean;
    IsSchoolAdmin: boolean;
    IsStudent: boolean;
    IsParent: boolean;
    IsMultiRole: boolean;

    LastName: string;
    LocalJobTitle: string;
    OAuthLogin: boolean;
    PositionNo: string;
    SAPID: string;

    // Unused?
    Email?: string;
    UserID?: number;
    FocusStaffID?: number;
    Roles: UserRole;
    IsImpersonation?: boolean;
    ImpersonatorSAPID?: string;
    ImpersonatorUserID?: number;
    ImpersonatorUsername?: string;
}

export class UserRole {
    IsAdvisor: boolean;
    IsCollegeAdmin: boolean;
    IsCollegeSupport: boolean;
    IsCounselor: boolean;
    IsDeveloper: boolean;
    IsDistrictAdmin: boolean;
    IsDistrictUser: boolean;
    IsParent: boolean;
    IsSchoolAdmin: boolean;
    IsStudent: boolean;
    IsMultiRole: boolean;
}



// WEBPACK FOOTER //
// ./src/services/user/user.service.ts